import React, { useContext } from 'react';
import { ThemeContext } from "../../../lib/theming/ThemeContext";
import { CrossIcon } from "../../../internal/icons/CrossIcon";
import { cx } from "../../../lib/theming/Emotion";
import { keyListener } from "../../../lib/events/keyListener";
import { styles } from "../Modal.styles";
export function ModalClose(_ref) {
  var _cx;

  var disableClose = _ref.disableClose,
      requestClose = _ref.requestClose;
  var theme = useContext(ThemeContext);

  var _React$useState = React.useState(false),
      focusedByTab = _React$useState[0],
      setFocusedByTab = _React$useState[1];

  var handleFocus = function handleFocus() {
    // focus event fires before keyDown eventlistener
    // so we should check tabPressed in async way
    requestAnimationFrame(function () {
      if (keyListener.isTabPressed) {
        setFocusedByTab(true);
      }
    });
  };

  var handleBlur = function handleBlur() {
    setFocusedByTab(false);
  };

  return /*#__PURE__*/React.createElement("button", {
    className: cx((_cx = {}, _cx[styles.close(theme)] = true, _cx[styles.disabled(theme)] = disableClose, _cx[styles.focus(theme)] = focusedByTab, _cx)),
    onClick: requestClose,
    onFocus: handleFocus,
    onBlur: handleBlur,
    "data-tid": "modal-close",
    tabIndex: disableClose ? -1 : 0
  }, /*#__PURE__*/React.createElement(CrossIcon, null));
}